import { cva } from '@/styled-system/css';

export const propertyCardRootRecipe = cva({
  base: {
    blockSize: 'fit-content', // fix: bug in Safari where PropertyCardPhoto height is incorrect
  },
  variants: {
    appearance: {
      large: {
        blockSize: '100%',
        minWidth: '286px',
        maxWidth: '386px',
      },
      small: {
        'minWidth': '144px',
        'maxWidth': '244px',

        // Give dataArea5 margin when it's below the card body
        '& > [data-c11n-component="PropertyCard.DataArea"]': {
          marginBlockStart: 'tighter',
        },
      },
      horizontal: {
        'minWidth': '293px',
        'maxWidth': '393px',

        // Give dataArea5 margin when it's below the card body
        '& > [data-c11n-component="PropertyCard.DataArea"]': {
          marginBlockStart: 'tighter',
        },
      },
    },
  },
});
